<form action="" class="sector-dropdown p-0">
  <app-dropdown-input
    label=""
    bindLabel="name"
    bindValue="id"
    [list]="sectors"
    placeholder="Select Sector"
    [isRequired]="false"
    [control]="utilityService.$formControl(sectorForm.get('sectors')!)"
    (onValueSelect)="onSectorSelect.emit($event)"
  ></app-dropdown-input>
</form>
